import BaseStyle from '@primevue/core/base/style';

var classes = {
  root: 'p-steppanels'
};
var StepPanelsStyle = BaseStyle.extend({
  name: 'steppanels',
  classes: classes
});

export { StepPanelsStyle as default };
//# sourceMappingURL=index.mjs.map
